import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { style: {"display":"flex","align-items":"center","justify-content":"space-between","width":"100%"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Home = _resolveComponent("Home")!
  const _component_n_icon = _resolveComponent("n-icon")!
  const _component_n_breadcrumb_item = _resolveComponent("n-breadcrumb-item")!
  const _component_n_breadcrumb = _resolveComponent("n-breadcrumb")!
  const _component_Sunny = _resolveComponent("Sunny")!
  const _component_Moon = _resolveComponent("Moon")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_space = _resolveComponent("n-space")!
  const _component_n_layout_header = _resolveComponent("n-layout-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_n_layout_content = _resolveComponent("n-layout-content")!
  const _component_n_layout = _resolveComponent("n-layout")!

  return (_openBlock(), _createBlock(_component_n_layout, {
    style: {"height":"100vh"},
    position: "absolute"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_n_layout_header, {
        bordered: "",
        position: "absolute",
        style: {"height":"64px","padding":"0 24px","display":"flex","align-items":"center","z-index":"1000"}
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_n_breadcrumb, null, {
              default: _withCtx(() => [
                _createVNode(_component_n_breadcrumb_item, {
                  onClick: _ctx.goHome,
                  style: {"cursor":"pointer"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_n_icon, {
                      size: "18",
                      style: {"vertical-align":"-0.15em","margin-right":"4px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Home)
                      ]),
                      _: 1
                    }),
                    _cache[0] || (_cache[0] = _createTextVNode(" 首页 ", -1))
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.breadcrumbItems, (item) => {
                  return (_openBlock(), _createBlock(_component_n_breadcrumb_item, {
                    key: item.path,
                    onClick: ($event: any) => (_ctx.navigateTo(item.path)),
                    style: {"cursor":"pointer"}
                  }, {
                    default: _withCtx(() => [
                      (item.icon)
                        ? (_openBlock(), _createBlock(_component_n_icon, {
                            key: 0,
                            size: "18",
                            style: {"vertical-align":"-0.15em","margin-right":"4px"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon)))
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(item.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                }), 128))
              ]),
              _: 1
            }),
            _createVNode(_component_n_space, null, {
              default: _withCtx(() => [
                _createVNode(_component_n_button, {
                  circle: "",
                  quaternary: "",
                  onClick: _ctx.toggleTheme
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_n_icon, { size: "20" }, {
                      default: _withCtx(() => [
                        (!_ctx.isDark)
                          ? (_openBlock(), _createBlock(_component_Sunny, { key: 0 }))
                          : (_openBlock(), _createBlock(_component_Moon, { key: 1 }))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_n_layout_content, {
        position: "absolute",
        style: {"top":"64px","padding":"24px","overflow-y":"auto"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_router_view)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}